import PageHeadline from "../../PageHeadline/PageHeadline";
import PageContentContainer from "../../Container/PageContentContainer";
import AttachmentFilter from "../../BeaAttachmentFilter/AttachmentFilter.tsx";

export default function AttachmentFilterPage() {
  return (
    <PageContentContainer size={"tiny"}>
      <PageHeadline main="Anhangsfilter" />
      <AttachmentFilter />
    </PageContentContainer>
  );
}
